import { createContext, useState } from "react";

export const MensajeContActualizacion=createContext<any>("");

export const MensajeActualizacionCon=({children}:any)=>
{
    const [Loadings,SetLoading]=useState<boolean>(false)
    return (
        <MensajeContActualizacion.Provider value={{Loadings,SetLoading}}>
            {children}
        </MensajeContActualizacion.Provider>
    )
}